import { FC, HTMLAttributes, ReactNode } from 'react'
import tw from 'tailwind-styled-components'

type Props = Omit<HTMLAttributes<HTMLDivElement>, 'id'> & {
  id: ReactNode
}

const TagContainer = tw.div`
  inline-block
  px-2
  py-[5px]
  rounded
  bg-gray-300
`
const TagTitle = tw.p`
  font-bold
  text-xs
  uppercase
  text-gray-600
`

export const IdTag: FC<Props> = ({ id, ...props }) => (
  <TagContainer {...props}>
    <TagTitle>ID {id}</TagTitle>
  </TagContainer>
)
